import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.6 10.9679L2.27937 6.40741C2.10205 6.25542 2 6.03354 2 5.8V1.8C2 1.35817 2.35817 1 2.8 1H17.2C17.6418 1 18 1.35817 18 1.8V5.8C18 5.85207 17.9949 5.90356 17.9851 5.95382C17.9693 6.03492 17.9412 6.11165 17.9029 6.18199C17.8569 6.26666 17.7955 6.34326 17.7206 6.40741L12.4 10.9679V17C12.4 17.3671 12.1502 17.6871 11.794 17.7761L8.59403 18.5761C8.08911 18.7023 7.6 18.3205 7.6 17.8V10.9679ZM15.038 6.59993L11.0798 9.99271C10.9024 10.1447 10.8004 10.3666 10.8004 10.6001V16.3755L9.20039 16.7755V10.6001C9.20039 10.3666 9.09833 10.1447 8.92102 9.99271L3.60038 5.43216V2.60011H16.4004V4.99993H10.7999C10.358 4.99993 9.99987 5.3581 9.99987 5.79993C9.99987 6.24176 10.358 6.59993 10.7999 6.59993H15.038Z",
		fill: "currentColor"
	})
});
export default SvgFilterFilled;
